export default __webpack_public_path__ + "static/media/amazon.cd2f59d0.png";